import { combineReducers } from 'redux'
import {
  JENISBARANG_GET_LOADING,
  JENISBARANG_GET_ERROR,
  JENISBARANG_GET_SUCCESS,

  JENISBARANG_VIEW_LOADING,
  JENISBARANG_VIEW_ERROR,
  JENISBARANG_VIEW_SUCCESS,

  JENISBARANG_ADD_LOADING,
  JENISBARANG_ADD_ERROR,
  JENISBARANG_ADD_SUCCESS,

  JENISBARANG_EDIT_LOADING,
  JENISBARANG_EDIT_ERROR,
  JENISBARANG_EDIT_SUCCESS,

  JENISBARANG_DELETE_LOADING,
  JENISBARANG_DELETE_ERROR,
  JENISBARANG_DELETE_SUCCESS,
} from '../actions/constant'

const jenisbarangGetError = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_GET_ERROR:
      return action.jenisbarangGetError
    default:
      return state
  }
}

const jenisbarangGetLoading = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_GET_LOADING:
      return action.jenisbarangGetLoading
    default:
      return state
  }
}

const jenisbarangGetSuccess = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_GET_SUCCESS:
      return action.jenisbarangGetSuccess
    default:
      return state
  }
}

const jenisbarangs = (state = [], action) => {
  switch (action.type) {
    case JENISBARANG_GET_SUCCESS:
      return action.jenisbarangs
    default:
      return state
  }
}

const jenisbarangViewError = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_VIEW_ERROR:
      return action.jenisbarangViewError
    default:
      return state
  }
}

const jenisbarangViewLoading = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_VIEW_LOADING:
      return action.jenisbarangViewLoading
    default:
      return state
  }
}

const jenisbarangViewSuccess = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_VIEW_SUCCESS:
      return action.jenisbarangViewSuccess
    default:
      return state
  }
}

const jenisbarang = (state = [], action) => {
  switch (action.type) {
    case JENISBARANG_VIEW_SUCCESS:
      return action.jenisbarang
    default:
      return state
  }
}

const jenisbarangAddError = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_ADD_ERROR:
      return action.jenisbarangAddError
    default:
      return state
  }
}

const jenisbarangAddLoading = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_ADD_LOADING:
      return action.jenisbarangAddLoading
    default:
      return state
  }
}

const jenisbarangAddSuccess = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_ADD_SUCCESS:
      return action.jenisbarangAddSuccess
    default:
      return state
  }
}

const jenisbarangEditError = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_EDIT_ERROR:
      return action.jenisbarangEditError
    default:
      return state
  }
}

const jenisbarangEditLoading = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_EDIT_LOADING:
      return action.jenisbarangEditLoading
    default:
      return state
  }
}

const jenisbarangEditSuccess = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_EDIT_SUCCESS:
      return action.jenisbarangEditSuccess
    default:
      return state
  }
}

const jenisbarangDeleteError = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_DELETE_ERROR:
      return action.jenisbarangDeleteError
    default:
      return state
  }
}

const jenisbarangDeleteLoading = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_DELETE_LOADING:
      return action.jenisbarangDeleteLoading
    default:
      return state
  }
}

const jenisbarangDeleteSuccess = (state = false, action) => {
  switch (action.type) {
    case JENISBARANG_DELETE_SUCCESS:
      return action.jenisbarangDeleteSuccess
    default:
      return state
  }
}

const jenisbarangReducer = combineReducers({
  jenisbarangGetError,
  jenisbarangGetLoading,
  jenisbarangGetSuccess,
  jenisbarangs,

  jenisbarangViewError,
  jenisbarangViewLoading,
  jenisbarangViewSuccess,
  jenisbarang,

  jenisbarangAddError,
  jenisbarangAddLoading,
  jenisbarangAddSuccess,

  jenisbarangEditError,
  jenisbarangEditLoading,
  jenisbarangEditSuccess,

  jenisbarangDeleteError,
  jenisbarangDeleteLoading,
  jenisbarangDeleteSuccess,
})

export default jenisbarangReducer
